import { NAME as namespace } from './constants';
import { plagiarismReducer as reducer } from './reducer';
export var plagiarism = {
  namespace: namespace,
  reducer: reducer
};
export default plagiarism;